import type {
  IEngagementUIElement,
  IEngagementWidget,
  IEngagementTeaser,
  InputParams,
} from '@schibsted/pulse-sdk';
import type { PulseContextInputParams } from '../../types/index.js';

import { createObjectSdrn } from './create-object-sdrn.js';

type EngagementEvent =
  | IEngagementUIElement
  | IEngagementWidget
  | IEngagementTeaser;

type ElementType = 'Teaser' | 'Widget' | 'UIElement';

export const buildEngagementClickEvent = <TEvent extends EngagementEvent>({
  elementType,
  event,
  providerId,
  providerInput,
}: {
  elementType: ElementType;
  event: PulseContextInputParams<TEvent>;
  providerId: string;
  providerInput: InputParams<TEvent>['provider'];
}): InputParams<TEvent> => {
  const providedElementName = (
    event as { engagement?: { elementName?: string } }
  ).engagement?.elementName;

  return {
    ...event,
    engagement: {
      action: 'Click',
      elementName: providedElementName ?? event.object.name,
    },
    object: {
      ...event.object,
      objectSdrn: createObjectSdrn(
        providerId,
        elementType,
        event.object.objectId,
      ),
    },
    provider: providerInput,
  } as InputParams<TEvent>;
};
